import React, { Component } from 'react';

//IMPORT REDUX
import { connect } from 'react-redux';
import { addModalLoader } from '../../../redux/actions/ConfigFileAction'

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import { 
    Grid, 
    Segment, 
    Button, 
    Icon,
    Modal,
    Header,
    Image,
    Loader
} from 'semantic-ui-react';

// PDF 
import jsPDF from 'jspdf'

const mapStateToProps = state => ({
  app: state.app,
  configfile: state.configfile
})

const mapActionToProps = {
    addModalLoader: addModalLoader
}


class ConnectedModalLoader extends Component {
    constructor(props) {
        super(props);

        
        this.closeModalLoader = this.closeModalLoader.bind(this)
    }

    openModalLoader(){
        this.props.addModalLoader(true)
    }
    closeModalLoader(){
        this.props.addModalLoader(false)
    }

    

    render() {
        return (
            <div>
                <Modal
                    open={this.props.configfile.modal_loader}
                    onClose={this.closeModalLoader}
                    basic 
                    size='small'
                    
                >

                    
                    <Modal.Content>
                        <Loader content='Loading' />
                    </Modal.Content>
                    
                        
                </Modal>
            </div>
        )

  }
}

const ModalLoader = connect(mapStateToProps, mapActionToProps)(ConnectedModalLoader);
export default ModalLoader;


// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/ModalLoader.jsx